import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'reactstrap'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import LoadingSpinner from '../LoadingSpinner'
import StatusMessage from '../StatusMessage'

const PageLayout = ({
  title,
  breadcrumbItem,
  children,
  isLoading = false,
  error = null,
  success = null,
  actions = null,
  containerFluid = true
}) => {
  const ContainerComponent = containerFluid ? Container : 'div'
  const containerProps = containerFluid ? { fluid: true } : {}

  return (
    <div className="page-content">
      <ContainerComponent {...containerProps}>
        <Breadcrumbs title={title} breadcrumbItem={breadcrumbItem} />

        <StatusMessage success={success} error={error} />

        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <Row>
              <Col lg={12}>
                {children}
              </Col>
            </Row>

            {actions && (
              // Sticky on phones so "Salvar" is always one tap away on long forms.
              <div className="page-actions-bar mt-4 mb-4">
                <div className="d-flex justify-content-end gap-2">
                  {actions}
                </div>
              </div>
            )}
          </>
        )}
      </ContainerComponent>
    </div>
  )
}

PageLayout.propTypes = {
  title: PropTypes.string.isRequired,
  breadcrumbItem: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  success: PropTypes.string,
  actions: PropTypes.node,
  containerFluid: PropTypes.bool
}

export default PageLayout
